<mat-icon svgIcon="question-answer" class="icon"></mat-icon>

<div class="title" trans>Do you have any questions about PRO accounts?</div>
<div class="subtitle" trans>Our support team will be happy to assist you.</div>
<a mat-raised-button color="primary" target="_blank" routerLink="/contact" trans>Contact Us</a>